import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Hourglass"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 8.7525V3H19.5V1.5H4.5V3H6.75V8.7525C6.75 9.07706 6.85527 9.39286 7.05 9.6525L8.8125 12L7.05 14.3475C6.85527 14.6071 6.75 14.9229 6.75 15.2475V21H4.5V22.5H19.5V21H17.25V15.2475C17.25 14.9229 17.1447 14.6071 16.95 14.3475L15.1875 12L16.95 9.6525C17.1447 9.39286 17.25 9.07706 17.25 8.7525ZM15.75 3V8.25H8.25V3H15.75ZM15.75 21V15.2475L13.3125 12L15 9.75H9L10.6875 12L8.25 15.2475V21H15.75ZM11.25 14.25H12.75V15.75H11.25V14.25ZM12.75 17.25H11.25V18.75H12.75V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Hourglass.vue"]]);
